import Button from '@mui/material/Button';
import { useFormikContext } from 'formik';

import { buttonField } from '../../../../types';

type Props = {
  children: string;
};
const ButtonWrapper = ({ children }: Props) => {
  const { submitForm } = useFormikContext();
  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    submitForm();
  };
  const configButton: buttonField = {
    onClick: handleSubmit,
    variant: 'contained',
    color: 'primary',
    fullWidth: true,
  };
  return (
    <Button
      {...configButton}
      style={{ width: '270px' }}
      type='submit'
      data-testid='formik-submit-button'
    >
      {children}
    </Button>
  );
};

export default ButtonWrapper;
